import jsPDF from 'jspdf';

import { BASE64_FONT_DATA, BASE64_LOGO_DATA } from '@/util/base64-string-data';
import { BASE64_NOTOSANKR_FONT_BOLD_DATA } from '@/util/base64-notosanKr-bold-font-string';
import { BASE64_NOTOSANKR_FONT_REGULAR_DATA } from '@/util/base64-notosanKr-regular-font-string';
import autoTable from 'jspdf-autotable';
import moment from 'moment';
import { FILE_TYPES } from '@/constants';

export function changeColorTheme(selectedColorThemeInput: string) {
  if (selectedColorThemeInput == 'system') {
    const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    selectedColorThemeInput = prefersDark ? 'dark' : 'light';
  }
  document.documentElement.setAttribute('data-theme', selectedColorThemeInput);
  localStorage.setItem('theme', selectedColorThemeInput);
}

export function onErrorImageAvatar(event) {
  if (event) {
    event.target.src = 'content/images/images_v3/common/go-empty-profile-sz96.png';
  }
}

export function onErrorImageCompany(event) {
  if (event) {
    event.target.src = 'content/images/images_v3/common/go-empty-company-sz96.png';
  }
}

export function randomSize() {
  // random size 1x2 or 2x1
  return Math.floor(Math.random() * 2) === 0 ? '1x2' : '2x1';
}

export function checkToShow(target: string, formModelInput: any) {
  // this.$route.name === 'Home'
  // this.$route.name === 'SocialBriefing-Detail'
  // this.$route.name === 'SearchReport'
  // this.$route.name === 'SearchDiscovery'
  // this.$route.name === 'Resource'

  // console.log(this.$route.name);

  // target define(moreButton, shareButton, hideButton)
  switch (target) {
    case 'moreButton':
      if (formModelInput?.type) {
        if (formModelInput?.type !== 'REPORT') {
          if (
            this.$route.name === 'SocialBriefing-Detail' ||
            this.$route.name === 'SearchReport' ||
            this.$route.name === 'SearchDiscovery' ||
            this.$route.name === 'Resource'
          ) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      } else {
        return false;
      }
    case 'shareButton':
      if (formModelInput?.type) {
        if (formModelInput?.type !== 'REPORT') {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    case 'hideButton':
      if (
        this.$route.name === 'SocialBriefing-Detail' ||
        this.$route.name === 'SearchReport' ||
        this.$route.name === 'SearchDiscovery' ||
        this.$route.name === 'Resource' ||
        this.$route.name === 'SocialUser'
      ) {
        return false;
      } else {
        // console.log(formModelInput);
        if (
          formModelInput?.isShowSourceReference &&
          (formModelInput?.isShowSourceReference === true || formModelInput?.isShowSourceReference === false)
        ) {
          return false;
        } else {
          return true;
        }
      }
    default:
      return false;
  }
}

export async function getBase64FontFromS3(url) {
  let response;
  await fetch(url).then(res => {
    response = res;
  });
  console.log('response', response.ok);
  if (!response.ok) {
    throw new Error('Network response was not odk');
  }
  const base64String = await response.text(); // Read the response as text
  return base64String;
}

export async function downloadFilePDFCommon(
  dataBodyInput?: any,
  dataTableOfContentInput?: any,
  dataHeadingInput?: any,
  dataReferenceInput?: any
) {
  try {
    const pdfReport = new jsPDF('p', 'mm', 'a4');
    const defaultXPosition = 15;
    const titleFontSize = 26;
    const defaultYPosition = 20;
    const tableOfSectionContentTextFontSize = 15;
    const headingTextFontSize = 13;
    const defaultTextFontSize = 13;
    const headUrlTextFontSize = 10;
    const urlFontSize = 8;
    const imageThumbnailHeight = 180;
    const imageThumbnailWidth = 180;
    const maxWidthText = 180;
    const maxYPosition = 297 - defaultYPosition;
    const mid = pdfReport.internal.pageSize.getWidth() / 2;
    let yPosition = 220;
    let pdfName = '';
    let lastIndexHeadingNumber = 0;
    const cellPadding = 4;
    const base64LogoString = BASE64_LOGO_DATA;

    let base64String = '';
    await getBase64FontFromS3(BASE64_FONT_DATA).then(res => {
      base64String = res;
    });

    let base64NoToSanKrFontBoldString = '';
    let base64NoToSanKrFontRegularString = '';
    await Promise.all([getBase64FontFromS3(BASE64_NOTOSANKR_FONT_BOLD_DATA), getBase64FontFromS3(BASE64_NOTOSANKR_FONT_REGULAR_DATA)]).then(
      responses => {
        base64NoToSanKrFontBoldString = responses[0];
        base64NoToSanKrFontRegularString = responses[1];
      }
    );

    let base64ImageThumbnail = '';
    console.log('base64String', base64String);
    pdfReport.addFileToVFS('NotoSansKR.ttf', base64String);
    pdfReport.addFileToVFS('NotoSansKR-Bold.ttf', base64NoToSanKrFontBoldString);
    pdfReport.addFileToVFS('NotoSansKR-Regular.ttf', base64NoToSanKrFontRegularString);

    pdfReport.addFont('NotoSansKR.ttf', 'NotoSansKR', 'normal');
    pdfReport.addFont('NotoSansKR-Bold.ttf', 'NotoSansKR-Bold', 'bold');
    pdfReport.addFont('NotoSansKR-Regular.ttf', 'NotoSansKR-Regular', 'normal');

    pdfReport.setFont('NotoSansKR', 'normal');

    if (dataHeadingInput?.data?.title?.content) {
      pdfName = dataHeadingInput.data?.title?.content + '.pdf';
    } else {
      pdfName = 'Report.pdf';
    }

    await imageUrlToBase64(
      dataHeadingInput?.data?.title_image?.content
        ? dataHeadingInput?.data?.title_image?.content
        : 'content/images/images_v3/common/go-empty-thumb-sz64.png'
    )
      .then(base64 => {
        base64ImageThumbnail = base64;
      })
      .catch(error => {
        base64ImageThumbnail = dataHeadingInput?.data?.title_image?.content
          ? dataHeadingInput?.data?.title_image?.content
          : 'content/images/images_v3/common/go-empty-thumb-sz64.png';

        console.error('Error:', error);
      });

    pdfReport.addImage(base64ImageThumbnail, 'JPEG', defaultXPosition, defaultYPosition, imageThumbnailWidth, imageThumbnailHeight);

    pdfReport.setFont('NotoSansKR-Bold', 'bold');
    const titleText = pdfReport.setFontSize(titleFontSize).splitTextToSize(dataHeadingInput?.data?.title?.content, 170);
    pdfReport.text(titleText, mid, yPosition, { align: 'center', maxWidth: 170 });
    yPosition = makeNextYPosition(yPosition, pdfReport, titleText, 10);

    pdfReport.setFont('NotoSansKR', 'normal');
    const subTitleText = pdfReport
      .setFontSize(15)
      .splitTextToSize(dataHeadingInput?.data?.publisher?.content.concat('  •  ' + dataHeadingInput?.data?.date?.content), 170);
    pdfReport.text(subTitleText, mid, yPosition, { align: 'center', maxWidth: 170 });

    pdfReport.addImage(base64LogoString, 'JPEG', mid - 16, 275, 32, 8);

    pdfReport.addPage();
    yPosition = defaultYPosition;

    if (dataTableOfContentInput && dataTableOfContentInput.data && dataTableOfContentInput.data.table_of_entry?.length > 0) {
      pdfReport.setFont('NotoSansKR-Bold', 'bold');
      const tableOfSectionContentText = pdfReport
        .setFontSize(tableOfSectionContentTextFontSize)
        .splitTextToSize(dataTableOfContentInput?.data?.table_of_section?.content, maxWidthText);
      pdfReport.text(tableOfSectionContentText, mid, yPosition, { align: 'center', maxWidth: maxWidthText });

      yPosition = makeNextYPosition(yPosition, pdfReport, tableOfSectionContentText, 5);

      pdfReport.setFont('NotoSansKR', 'normal');

      dataTableOfContentInput?.data?.table_of_entry?.forEach((item, index) => {
        const headingText = pdfReport
          .setFontSize(headingTextFontSize)
          .splitTextToSize((index + 1).toString().concat('. ' + item.content), maxWidthText);
        pdfReport.text(headingText, defaultXPosition, yPosition, { align: 'left', maxWidth: maxWidthText });

        yPosition = makeNextYPosition(yPosition, pdfReport, headingText, 5);
      });

      pdfReport.addPage();
      yPosition = defaultYPosition;
    }

    let subTitleIndex = 0;
    let isHaveChildTextLoop = false;

    dataBodyInput.forEach((dataBodyItem, index) => {
      pdfReport.setLineHeightFactor(1.6);
      pdfReport.setFont('NotoSansKR', 'normal');
      subTitleIndex = 0;
      let tempText = '';
      let tableHeight = 0;

      if (index > 0) {
        yPosition = yPosition + 5;
        // pdfReport.line(defaultXPosition - 5, yPosition, 200, yPosition);
        yPosition = yPosition + 15;
      }

      if (dataBodyItem?.elements && dataBodyItem?.elements?.length > 0) {
        dataBodyItem?.elements?.forEach(item => {
          pdfReport.setLineHeightFactor(1.6);
          pdfReport.setFont('NotoSansKR', 'normal');
          tempText = '';
          tableHeight = 0;

          switch (item.elementType || item.element_type) {
            case 'bold_text':
              if (item?.content) {
                pdfReport.setFont('NotoSansKR-Bold', 'bold');
                tempText = pdfReport.setFontSize(headingTextFontSize).splitTextToSize(item?.content, maxWidthText);

                if (makeNextYPosition(yPosition, pdfReport, tempText, 0) > maxYPosition) {
                  pdfReport.addPage();
                  yPosition = defaultYPosition;
                }

                pdfReport.text(tempText, defaultXPosition, yPosition, { align: 'left', maxWidth: maxWidthText });
              }

              break;

            case 'bullet_lst':
              if (item?.content) {
                tempText = pdfReport.setFontSize(defaultTextFontSize).splitTextToSize('•   ' + item?.content, maxWidthText);

                if (makeNextYPosition(yPosition, pdfReport, tempText, 0) > maxYPosition) {
                  pdfReport.addPage();
                  yPosition = defaultYPosition;
                }

                pdfReport.text(tempText, defaultXPosition, yPosition, { align: 'left', maxWidth: maxWidthText });
              }

              break;

            case 'heading':
              if (item?.content) {
                pdfReport.setFont('NotoSansKR-Bold', 'bold');

                lastIndexHeadingNumber = index + 1;

                tempText = pdfReport
                  .setFontSize(tableOfSectionContentTextFontSize)
                  .splitTextToSize((index + 1).toString().concat('. ' + item?.content), maxWidthText);

                if (makeNextYPosition(yPosition, pdfReport, tempText, 0) > maxYPosition) {
                  pdfReport.addPage();
                  yPosition = defaultYPosition;
                }

                pdfReport.text(tempText, defaultXPosition - 4, yPosition, { align: 'left', maxWidth: maxWidthText });
              }

              break;

            case 'heading_without_no':
              if (item?.content) {
                pdfReport.setFont('NotoSansKR-Bold', 'bold');

                tempText = pdfReport.setFontSize(tableOfSectionContentTextFontSize).splitTextToSize(item?.content, maxWidthText);

                if (makeNextYPosition(yPosition, pdfReport, tempText, 3) > maxYPosition) {
                  pdfReport.addPage();
                  yPosition = defaultYPosition;
                } else {
                  yPosition = yPosition + 3;
                }

                pdfReport.text(tempText, defaultXPosition - 4, yPosition, { align: 'left', maxWidth: maxWidthText });
              }

              break;

            case 'subheading':
              if (item?.content) {
                pdfReport.setFont('NotoSansKR-Bold', 'bold');

                subTitleIndex++;

                tempText = pdfReport.setFontSize(headingTextFontSize).splitTextToSize(
                  (index + 1)
                    .toString()
                    .concat('-' + subTitleIndex)
                    .concat('. ' + item?.content),
                  maxWidthText
                );

                if (makeNextYPosition(yPosition, pdfReport, tempText, 3) > maxYPosition) {
                  pdfReport.addPage();
                  yPosition = defaultYPosition;
                } else {
                  yPosition = yPosition + 3;
                }

                pdfReport.text(tempText, defaultXPosition, yPosition, { align: 'left', maxWidth: maxWidthText });
              }

              break;

            case 'subheading_without_no':
              if (item?.content) {
                pdfReport.setFont('NotoSansKR-Bold', 'bold');

                yPosition = yPosition + 2;
                tempText = pdfReport.setFontSize(headingTextFontSize).splitTextToSize(item?.content, maxWidthText);

                if (makeNextYPosition(yPosition, pdfReport, tempText, 0) > maxYPosition) {
                  pdfReport.addPage();
                  yPosition = defaultYPosition;
                }

                pdfReport.text(tempText, defaultXPosition, yPosition, { align: 'left', maxWidth: maxWidthText });
              }

              break;

            case 'list':
              if (item?.content && item?.content?.length > 0) {
                item?.content.forEach(contentItem => {
                  tempText = pdfReport.setFontSize(defaultTextFontSize).splitTextToSize(contentItem || '', maxWidthText);

                  if (makeNextYPosition(yPosition, pdfReport, tempText, 0) > maxYPosition) {
                    pdfReport.addPage();
                    yPosition = defaultYPosition;
                  }

                  pdfReport.text(tempText, defaultXPosition, yPosition, { align: 'left', maxWidth: maxWidthText });

                  if (contentItem) {
                    yPosition = makeNextYPosition(yPosition, pdfReport, tempText, 5);
                    isHaveChildTextLoop = true;
                  }
                });
              }

              break;

            case 'table':
              if (item?.content) {
                pdfReport.setLineHeightFactor(1);
                pdfReport.setFont('NotoSansKR-Regular', 'normal');
                const tempHeaderList = [];

                if (item?.content?.schema?.fields?.length > 0) {
                  item?.content?.schema?.fields?.forEach(field => {
                    tempHeaderList.push(field.name);
                  });
                }

                if (!tempHeaderList || tempHeaderList.length === 0) {
                  break;
                }

                const numberOfColumns = tempHeaderList.length;
                const columnWidth = Math.ceil(180 / numberOfColumns);

                let headerHeight = 0;
                let tempTextColumn = '';
                let tempTextHeader = '';
                let columnHeight = 0;

                tempTextHeader = findLongestText(tempHeaderList);
                tempTextHeader = pdfReport
                  .setFontSize(defaultTextFontSize)
                  .splitTextToSize(tempTextHeader, columnWidth - cellPadding * 2 + 1);
                headerHeight = headerHeight + Math.ceil(pdfReport.getTextDimensions(tempTextHeader).h + 5.4);

                item?.content?.data.forEach(dataItemColumn => {
                  tempTextColumn = findLongestText(dataItemColumn);
                  tempTextColumn = pdfReport
                    .setFontSize(defaultTextFontSize)
                    .splitTextToSize(tempTextColumn, columnWidth - cellPadding * 2 + 1);

                  if (pdfReport.getTextDimensions(tempTextColumn).h > 5) {
                    columnHeight = columnHeight + Math.ceil(pdfReport.getTextDimensions(tempTextColumn).h + 1.2);
                  } else {
                    columnHeight = columnHeight + Math.ceil(pdfReport.getTextDimensions(tempTextColumn).h + 0.2);
                  }
                });

                tableHeight = headerHeight + columnHeight + cellPadding * 2 * (item?.content?.data.length + 1);

                const headers = tempHeaderList;
                const data = item.content.data;

                if (yPosition + tableHeight > maxYPosition) {
                  pdfReport.addPage();
                  yPosition = defaultYPosition;
                }

                autoTable(pdfReport, {
                  head: [headers],
                  body: data.map(row => headers.map(header => row[header] || '')),
                  startY: yPosition,
                  theme: 'striped',
                  margin: 0,
                  styles: {
                    fontSize: defaultTextFontSize,
                    cellPadding: cellPadding,
                    font: 'NotoSansKR-Regular',
                    lineWidth: 0.75,
                    lineColor: [0, 0, 0],
                  },
                  headStyles: {
                    lineWidth: 0.75,
                    lineColor: [0, 0, 0],
                    fillColor: [128, 128, 128],
                  },
                  columnStyles: headers.reduce((styles, _, index) => {
                    styles[index] = { cellWidth: columnWidth };
                    return styles;
                  }, {}),
                });
              }

              break;

            case 'grid':
              if (item?.content) {
                item.content.forEach(contentDataItem => {
                  contentDataItem?.elements?.forEach(gridItem => {
                    if (gridItem?.element_type) {
                      switch (gridItem.element_type) {
                        case 'subheading':
                          if (gridItem?.content) {
                            pdfReport.setFont('NotoSansKR-Bold', 'bold');

                            tempText = pdfReport.setFontSize(headingTextFontSize).splitTextToSize(gridItem?.content, maxWidthText);

                            if (makeNextYPosition(yPosition, pdfReport, tempText, 3) > maxYPosition) {
                              pdfReport.addPage();
                              yPosition = defaultYPosition;
                            } else {
                              yPosition = yPosition + 3;
                            }

                            pdfReport.text(tempText, defaultXPosition, yPosition, {
                              align: 'left',
                              maxWidth: maxWidthText,
                            });
                          }

                          break;

                        case 'paragraph':
                          if (gridItem?.content && gridItem?.content?.length > 0) {
                            gridItem?.content.forEach(paragraphText => {
                              tempText = pdfReport.setFontSize(defaultTextFontSize).splitTextToSize(paragraphText || '', maxWidthText);

                              if (makeNextYPosition(yPosition, pdfReport, tempText, 0) > maxYPosition) {
                                pdfReport.addPage();
                                yPosition = defaultYPosition;
                              }

                              pdfReport.text(tempText, defaultXPosition, yPosition, {
                                align: 'left',
                                maxWidth: maxWidthText,
                              });

                              if (paragraphText) {
                                yPosition = makeNextYPosition(yPosition, pdfReport, tempText, 5);
                                isHaveChildTextLoop = true;
                              }
                            });
                          }

                          break;
                      }

                      pdfReport.setFont('NotoSansKR', 'normal');

                      if (tempText && isHaveChildTextLoop === false) {
                        yPosition = makeNextYPosition(yPosition, pdfReport, tempText, 5);
                      }

                      isHaveChildTextLoop = false;
                    }
                  });
                });
              }

              break;

            case 'list-of-list':
              if (item?.content && typeof item?.content === 'string') {
                tempText = pdfReport.setFontSize(tableOfSectionContentTextFontSize).splitTextToSize(item?.content || '', maxWidthText);

                if (makeNextYPosition(yPosition, pdfReport, tempText, 0) > maxYPosition) {
                  pdfReport.addPage();
                  yPosition = defaultYPosition;
                }

                pdfReport.text(tempText, defaultXPosition, yPosition, { align: 'left', maxWidth: maxWidthText });
              }

              break;

            case '':
              if (item?.content && typeof item?.content === 'string') {
                tempText = pdfReport.setFontSize(tableOfSectionContentTextFontSize).splitTextToSize(item?.content || '', maxWidthText);

                if (makeNextYPosition(yPosition, pdfReport, tempText, 0) > maxYPosition) {
                  pdfReport.addPage();
                  yPosition = defaultYPosition;
                }

                pdfReport.text(tempText, defaultXPosition, yPosition, { align: 'left', maxWidth: maxWidthText });
              }

              break;
          }

          if ((item && item?.elementName?.includes('quote')) || item?.element_name?.includes('quote')) {
            switch (item.elementType || item.element_type) {
              case 'block_quote_1':
                if (item?.content) {
                  item?.content.forEach((obj, indexObj) => {
                    tempText = pdfReport.setFontSize(defaultTextFontSize).splitTextToSize(obj || '', maxWidthText);

                    if (makeNextYPosition(yPosition, pdfReport, tempText, 0) > maxYPosition) {
                      pdfReport.addPage();
                      yPosition = defaultYPosition;
                    }

                    pdfReport.text(tempText, defaultXPosition + 5, yPosition, {
                      align: 'left',
                      maxWidth: maxWidthText,
                    });

                    if (obj) {
                      yPosition = makeNextYPosition(yPosition, pdfReport, tempText, 5);
                      isHaveChildTextLoop = true;
                    }
                  });
                }

                break;

              case 'block_quote_2':
                if (item?.content) {
                  item?.content.forEach((obj, indexObj) => {
                    tempText = pdfReport.setFontSize(defaultTextFontSize).splitTextToSize(obj || '', maxWidthText);

                    if (makeNextYPosition(yPosition, pdfReport, tempText, 0) > maxYPosition) {
                      pdfReport.addPage();
                      yPosition = defaultYPosition;
                    }

                    pdfReport.text(tempText, defaultXPosition + 5, yPosition, {
                      align: 'left',
                      maxWidth: maxWidthText,
                    });

                    if (obj) {
                      yPosition = makeNextYPosition(yPosition, pdfReport, tempText, 5);
                      isHaveChildTextLoop = true;
                    }
                  });
                }

                break;

              case 'block_quote_3':
                if (item?.content) {
                  item?.content.forEach((obj, indexObj) => {
                    tempText = pdfReport.setFontSize(defaultTextFontSize).splitTextToSize(obj || '', maxWidthText);

                    if (makeNextYPosition(yPosition, pdfReport, tempText, 5) > maxYPosition) {
                      pdfReport.addPage();
                      yPosition = defaultYPosition;
                    }

                    pdfReport.text(tempText, defaultXPosition + 5, yPosition, {
                      align: 'left',
                      maxWidth: maxWidthText,
                    });

                    if (obj) {
                      yPosition = makeNextYPosition(yPosition, pdfReport, tempText, 5);
                      isHaveChildTextLoop = true;
                    }
                  });
                }

                break;

              case 'block_quote':
                if (item?.content) {
                  item?.content.forEach((obj, indexObj) => {
                    tempText = pdfReport.setFontSize(defaultTextFontSize).splitTextToSize(obj || '', maxWidthText);

                    if (makeNextYPosition(yPosition, pdfReport, tempText, 0) > maxYPosition) {
                      pdfReport.addPage();
                      yPosition = defaultYPosition;
                    }

                    pdfReport.text(tempText, defaultXPosition + 5, yPosition, {
                      align: 'left',
                      maxWidth: maxWidthText,
                    });

                    if (obj) {
                      yPosition = makeNextYPosition(yPosition, pdfReport, tempText, 5);
                      isHaveChildTextLoop = true;
                    }
                  });
                }

                break;
            }
          }

          pdfReport.setFont('NotoSansKR', 'normal');

          if (tableHeight !== 0) {
            yPosition = yPosition + tableHeight + 5;
          } else if (tempText && isHaveChildTextLoop === false) {
            yPosition = makeNextYPosition(yPosition, pdfReport, tempText, 5);
          }

          isHaveChildTextLoop = false;

          if (yPosition > maxYPosition) {
            pdfReport.addPage();
            yPosition = defaultYPosition;
          }
        });
      }

      if (yPosition > maxYPosition) {
        pdfReport.addPage();
        yPosition = defaultYPosition;
      }
    });

    let tempText = '';
    yPosition = yPosition + 5;

    if (yPosition > maxYPosition) {
      pdfReport.addPage();
      yPosition = defaultYPosition;
    }

    // pdfReport.line(defaultXPosition - 5, yPosition, 200, yPosition);
    yPosition = yPosition + 15;

    if (dataReferenceInput?.elements?.length > 0) {
      dataReferenceInput?.elements?.forEach((item, index) => {
        pdfReport.setFont('NotoSansKR', 'normal');
        isHaveChildTextLoop = false;

        switch (item?.elementType) {
          case 'heading':
            if (item?.content) {
              pdfReport.setFont('NotoSansKR-Bold', 'bold');

              tempText = pdfReport
                .setFontSize(tableOfSectionContentTextFontSize)
                .splitTextToSize((lastIndexHeadingNumber + index + 1).toString().concat('. ' + item?.content), maxWidthText);

              if (makeNextYPosition(yPosition, pdfReport, tempText, 0) > maxYPosition) {
                pdfReport.addPage();
                yPosition = defaultYPosition;
              }

              pdfReport.text(tempText, defaultXPosition - 4, yPosition, { align: 'left', maxWidth: maxWidthText });
            }
            break;

          case 'list':
            if (item?.contents && item?.contents?.length > 0) {
              item?.contents.forEach(contentItemData => {
                tempText = pdfReport
                  .setFontSize(headUrlTextFontSize)
                  .setTextColor('black')
                  .splitTextToSize(contentItemData.title || '', maxWidthText);

                if (makeNextYPosition(yPosition, pdfReport, tempText, 0) > maxYPosition) {
                  pdfReport.addPage();
                  yPosition = defaultYPosition;
                }

                pdfReport.text(tempText, defaultXPosition, yPosition, { align: 'left', maxWidth: maxWidthText });

                yPosition = makeNextYPosition(yPosition, pdfReport, tempText, 2);

                tempText = pdfReport
                  .setFontSize(urlFontSize)
                  .setTextColor('#747F85')
                  .splitTextToSize(contentItemData.url || '', maxWidthText);

                if (makeNextYPosition(yPosition, pdfReport, tempText, 0) > maxYPosition) {
                  pdfReport.addPage();
                  yPosition = defaultYPosition;
                }

                pdfReport.text(tempText, defaultXPosition, yPosition, { align: 'left', maxWidth: maxWidthText });

                pdfReport.link(
                  defaultXPosition,
                  yPosition,
                  pdfReport.getTextDimensions(tempText).w,
                  pdfReport.getTextDimensions(tempText).h - 5,
                  { url: contentItemData.url }
                );

                if (contentItemData.title || contentItemData.url) {
                  yPosition = makeNextYPosition(yPosition, pdfReport, tempText, 7);
                  isHaveChildTextLoop = true;
                }
              });
            }

            break;

          case 'heading_without_no':
            if (item?.content) {
              pdfReport.setFont('NotoSansKR-Bold', 'bold');

              tempText = pdfReport.setFontSize(tableOfSectionContentTextFontSize).splitTextToSize(item?.content, maxWidthText);

              if (makeNextYPosition(yPosition, pdfReport, tempText, 3) > maxYPosition) {
                pdfReport.addPage();
                yPosition = defaultYPosition;
              } else {
                yPosition = yPosition + 3;
              }

              pdfReport.text(tempText, defaultXPosition - 4, yPosition, { align: 'left', maxWidth: maxWidthText });
            }

            break;

          case 'entry':
            break;

          default:
            if (item?.content) {
              tempText = pdfReport.setFontSize(defaultTextFontSize).splitTextToSize(item?.content || '', maxWidthText);

              if (makeNextYPosition(yPosition, pdfReport, tempText, 0) > maxYPosition) {
                pdfReport.addPage();
                yPosition = defaultYPosition;
              }

              pdfReport.text(tempText, defaultXPosition, yPosition, { align: 'left', maxWidth: maxWidthText });

              if (item?.content || item?.url) {
                yPosition = makeNextYPosition(yPosition, pdfReport, tempText, 5);
                isHaveChildTextLoop = true;
              }
            }
        }

        pdfReport.setFont('NotoSansKR', 'normal');

        if (tempText && isHaveChildTextLoop === false) {
          yPosition = makeNextYPosition(yPosition, pdfReport, tempText, 5);
        }

        isHaveChildTextLoop = false;

        if (yPosition > maxYPosition) {
          pdfReport.addPage();
          yPosition = defaultYPosition;
        }
      });
    }

    pdfReport.save(pdfName);
  } catch (e) {
    console.log('Download failed pdf in common function with error: ', e);
  }
}

export async function downloadFilePDFTopic(topicDetail?: any, imageCoverdWidth?: number, imageCoverHeight?: number) {
  try {
    const pdfReport = new jsPDF('p', 'mm', 'a4');
    const defaultXPosition = 15;
    const titleFontSize = 26;
    const defaultYPosition = 20;
    const defaultTextFontSize = 13;
    const headUrlTextFontSize = 10;
    const urlFontSize = 8;
    const imageThumbnailHeight = 180;
    const imageThumbnailWidth = 180;
    const maxWidthText = 180;
    const maxYPosition = 297 - defaultYPosition;
    const mid = pdfReport.internal.pageSize.getWidth() / 2;
    let yPosition = 220;
    let pdfName = '';

    const base64LogoString = BASE64_LOGO_DATA;

    let base64String = '';
    await getBase64FontFromS3(BASE64_FONT_DATA).then(res => {
      base64String = res;
    });

    let base64NoToSanKrFontBoldString = '';
    let base64NoToSanKrFontRegularString = '';
    await Promise.all([getBase64FontFromS3(BASE64_NOTOSANKR_FONT_BOLD_DATA), getBase64FontFromS3(BASE64_NOTOSANKR_FONT_REGULAR_DATA)]).then(
      responses => {
        base64NoToSanKrFontBoldString = responses[0];
        base64NoToSanKrFontRegularString = responses[1];
      }
    );

    pdfReport.addFileToVFS('NotoSansKR.ttf', base64String);
    pdfReport.addFileToVFS('NotoSansKR-Bold.ttf', base64NoToSanKrFontBoldString);
    pdfReport.addFileToVFS('NotoSansKR-Regular.ttf', base64NoToSanKrFontRegularString);

    pdfReport.addFont('NotoSansKR.ttf', 'NotoSansKR', 'normal');
    pdfReport.addFont('NotoSansKR-Bold.ttf', 'NotoSansKR-Bold', 'bold');
    pdfReport.addFont('NotoSansKR-Regular.ttf', 'NotoSansKR-Regular', 'normal');

    pdfReport.setFont('NotoSansKR', 'normal');

    if (topicDetail?.topicTitle) {
      pdfName = topicDetail.topicTitle + '.pdf';
    } else {
      pdfName = 'Report.pdf';
    }

    pdfReport.setFont('NotoSansKR-Bold', 'bold');
    const titleText = pdfReport.setFontSize(titleFontSize).splitTextToSize(topicDetail.topicTitle, 180);
    pdfReport.text(titleText, mid, defaultYPosition, { align: 'center', maxWidth: 180 });
    yPosition = makeNextYPosition(defaultYPosition, pdfReport, titleText, 5);
    // console.log(yPosition)

    pdfReport.setFont('NotoSansKR', 'normal');
    pdfReport.setFontSize(15);
    const gooverFavIcon = await imageUrlToBase64('content/images/common/goover_favicon.png');
    // let gooverFavIconBase64 = '';
    // if (typeof gooverFavIcon === 'string' && gooverFavIcon.startsWith('data:image/')) {
    //   gooverFavIconBase64 = gooverFavIcon.split(',')[1];
    // }
    pdfReport.addImage(gooverFavIcon, 'JPEG', defaultXPosition, yPosition - 4, 5, 5);
    pdfReport.text('Summary', defaultXPosition + 6, yPosition, { align: 'left', maxWidth: 180 });
    // const subTitleText = pdfReport
    //   .setFontSize(15)
    //   .splitTextToSize('Automatic Summary'.concat('  •  ' + moment.utc(topicDetail.publishedDate).local().format('YYYY-MM-DD HH:mm')), 170);
    pdfReport.text(moment.utc(topicDetail.publishedDate).local().format('YYYY-MM-DD HH:mm'), maxWidthText + 15, yPosition, {
      align: 'right',
    });
    yPosition = makeNextYPosition(yPosition, pdfReport, titleText, 5);

    const coverImage = await imageUrlToBase64(topicDetail.coverImageUrl);
    // console.log('coverImage', coverImage);
    // let coverImageBase64 ='';
    // if (typeof coverImage === 'string' && coverImage.startsWith('data:image/')) {
    //   coverImageBase64  = coverImage.split(',')[1];
    // }

    const scaledWidth = imageThumbnailHeight;
    const scaledHeight = (scaledWidth * imageCoverHeight) / imageCoverdWidth;

    pdfReport.addImage(coverImage, 'JPEG', defaultXPosition, yPosition, scaledWidth, scaledHeight);
    yPosition = yPosition + scaledHeight;

    yPosition = makeNextYPosition(yPosition, pdfReport, titleText, 3);
    // console.log('scaledWidth',scaledWidth)
    // console.log('scaledHeight',scaledHeight)

    topicDetail.topicContent.forEach(topicContent => {
      let tempText = '';
      pdfReport.setFont('NotoSansKR', 'normal');
      tempText = pdfReport.setFontSize(defaultTextFontSize).splitTextToSize(topicContent, maxWidthText);
      if (makeNextYPosition(yPosition, pdfReport, tempText, 0) > maxYPosition) {
        pdfReport.addPage();
        yPosition = defaultYPosition;
      }
      pdfReport.text(tempText, defaultXPosition, yPosition, { align: 'left', maxWidth: maxWidthText });
      yPosition = makeNextYPosition(yPosition, pdfReport, tempText, 5);
    });
    const tempText = pdfReport
      .setFontSize(12)
      .setFont('NotoSansKR-Bold', 'bold')
      .setTextColor('#fd7e1c')
      .splitTextToSize('Subtopic', maxWidthText);
    if (makeNextYPosition(yPosition, pdfReport, tempText, 0) > maxYPosition) {
      pdfReport.addPage();
      yPosition = defaultYPosition;
    }
    pdfReport.text(tempText, defaultXPosition, yPosition, { align: 'left', maxWidth: maxWidthText });
    yPosition = makeNextYPosition(yPosition, pdfReport, tempText, 2);
    topicDetail.subTopics.forEach(subTopics => {
      let tempText = '';
      pdfReport.setFont('NotoSansKR-Bold', 'bold');
      tempText = pdfReport.setFontSize(15).setTextColor('#000000').splitTextToSize(subTopics.subTopicTitle, maxWidthText);

      if (makeNextYPosition(yPosition, pdfReport, tempText, 0) > maxYPosition) {
        pdfReport.addPage();
        yPosition = defaultYPosition;
      }
      pdfReport.text(tempText, defaultXPosition, yPosition, { align: 'left', maxWidth: maxWidthText });
      yPosition = makeNextYPosition(yPosition, pdfReport, tempText, 0);
      if (subTopics) {
        yPosition = makeNextYPosition(yPosition, pdfReport, tempText, 0);
      }
      subTopics.subTopicContent.forEach(subTopicContent => {
        pdfReport.setFont('NotoSansKR', 'normal');
        tempText = pdfReport.setFontSize(defaultTextFontSize).splitTextToSize(subTopicContent, maxWidthText);

        if (makeNextYPosition(yPosition, pdfReport, tempText, 0) > maxYPosition) {
          pdfReport.addPage();
          yPosition = defaultYPosition;
        }

        pdfReport.text(tempText, defaultXPosition + 4, yPosition, { align: 'left', maxWidth: maxWidthText });
        yPosition = makeNextYPosition(yPosition, pdfReport, tempText, 5);
      });
      tempText = pdfReport
        .setFontSize(12)
        .setFont('NotoSansKR-Bold', 'bold')
        .setTextColor('#0080FF')
        .splitTextToSize('Reference', maxWidthText);
      if (makeNextYPosition(yPosition, pdfReport, tempText, 0) > maxYPosition) {
        pdfReport.addPage();
        yPosition = defaultYPosition;
      }
      pdfReport.text(tempText, defaultXPosition + 4, yPosition, { align: 'left', maxWidth: maxWidthText });
      yPosition = makeNextYPosition(yPosition, pdfReport, tempText, 2);
      subTopics.subTopicDocList.forEach(subTopicDocList => {
        pdfReport.setFont('NotoSansKR', 'normal');
        tempText = pdfReport.setFontSize(headUrlTextFontSize).setTextColor('black').splitTextToSize(subTopicDocList.docTitle, maxWidthText);

        if (makeNextYPosition(yPosition, pdfReport, tempText, 0) > maxYPosition) {
          pdfReport.addPage();
          yPosition = defaultYPosition;
        }

        pdfReport.text(tempText, defaultXPosition + 8, yPosition, { align: 'left', maxWidth: maxWidthText });
        yPosition = makeNextYPosition(yPosition, pdfReport, tempText, 2);

        tempText = pdfReport
          .setFontSize(urlFontSize)
          .setTextColor('#747F85')
          .splitTextToSize(subTopicDocList.docUrl || '', maxWidthText);

        if (makeNextYPosition(yPosition, pdfReport, tempText, 0) > maxYPosition) {
          pdfReport.addPage();
          yPosition = defaultYPosition;
        }

        pdfReport.text(tempText, defaultXPosition + 8, yPosition, { align: 'left', maxWidth: maxWidthText });

        pdfReport.link(
          defaultXPosition + 12,
          yPosition,
          pdfReport.getTextDimensions(tempText).w,
          pdfReport.getTextDimensions(tempText).h - 5,
          { url: subTopicDocList.docUrl }
        );

        if (subTopicDocList.docTitle || subTopicDocList.docUrl) {
          yPosition = makeNextYPosition(yPosition, pdfReport, tempText, 7);
        }
      });
    });

    pdfReport.save(pdfName);
  } catch (e) {
    console.log('Download failed pdf in common function with error: ', e);
  }
}

function findLongestText(obj) {
  let maxLength = 0;
  let longestText = '';

  function traverse(currentObj) {
    if (typeof currentObj === 'object' && currentObj !== null) {
      for (const key in currentObj) {
        if (Object.hasOwnProperty.call(currentObj, key)) {
          const value = currentObj[key];
          if (typeof value === 'string') {
            if (value.length > maxLength) {
              maxLength = value.length;
              longestText = value;
            }
          } else if (typeof value === 'object') {
            traverse(value);
          }
        }
      }
    } else if (currentObj && Array.isArray(currentObj) && currentObj.length > 0) {
      for (const value of currentObj) {
        if (typeof value === 'string') {
          if (value.length > maxLength) {
            maxLength = value.length;
            longestText = value;
          }
        }
      }
    }
  }

  traverse(obj);
  return longestText;
}

function makeNextYPosition(yPositionInput: number, pdfReportInput: jsPDF, textInput: string, addMore: number) {
  return yPositionInput + Math.ceil(pdfReportInput.getTextDimensions(textInput).h) + addMore;
}

async function imageUrlToBase64(url: string): Promise<string> {
  let response;
  await fetch(url).then(res => {
    response = res;
  });

  if (!response.ok) {
    console.log(`Failed to fetch image from ${url}`);
  }

  const blob = await response.blob();

  const reader = new FileReader();

  return new Promise<string>((resolve, reject) => {
    reader.onloadend = () => {
      const base64String = (reader.result as string).split(',')[1];
      resolve(base64String);
    };

    reader.onerror = error => {
      reject(error);
    };

    reader.readAsDataURL(blob);
  });
}

function checkMediaType(mediaType: string): string {
  const upperCaseMediaType = mediaType.toUpperCase();
  const keywords = ['JOURNAL', 'PRODUCT', 'DAILY', 'INVESTMENT', 'SOCIAL_MEDIA', 'DOCX', 'REPORT'];
  return keywords.some(keyword => upperCaseMediaType.includes(keyword)) ? upperCaseMediaType : '';
}

export function makeReportTypeText(dataInput: any) {
  let tempReportTypeText = 'briefing.popup.createBriefing.reportTypeSelect.optionName.dailyReport';

  const tempListData = dataInput.originParentDocDetail?.media_type || dataInput.parentDocDetail?.media_type || [];

  if (!tempListData || (tempListData && tempListData.length === 0)) {
    return tempReportTypeText;
  }

  tempListData.forEach(mediaType => {
    const checkedMediaType = checkMediaType(mediaType);
    const isCheckedMediaTypeEmpty = checkedMediaType === '';
    if (isCheckedMediaTypeEmpty) {
      tempReportTypeText = '';
      return;
    }

    if (mediaType.toUpperCase().includes('INDEPTH_DAILY')) {
      tempReportTypeText = 'briefing.popup.createBriefing.reportTypeSelect.optionName.inDepthReportLabel';
      return 'briefing.popup.createBriefing.reportTypeSelect.optionName.inDepthReportLabel';
    }

    if (mediaType.toUpperCase().includes('JOURNAL')) {
      tempReportTypeText = 'briefing.popup.createBriefing.reportTypeSelect.optionName.journal';
      return 'briefing.popup.createBriefing.reportTypeSelect.optionName.journal';
    }

    if (mediaType.toUpperCase().includes('PRODUCT')) {
      tempReportTypeText = 'briefing.popup.createBriefing.reportTypeSelect.optionName.productReviewReport';
      return 'briefing.popup.createBriefing.reportTypeSelect.optionName.productReviewReport';
    }

    if (mediaType.toUpperCase().includes('DAILY') || mediaType.toUpperCase().includes('NONE')) {
      tempReportTypeText = 'briefing.popup.createBriefing.reportTypeSelect.optionName.dailyReport';
      return 'briefing.popup.createBriefing.reportTypeSelect.optionName.dailyReport';
    }

    if (mediaType.toUpperCase().includes('INVESTMENT')) {
      tempReportTypeText = 'briefing.popup.createBriefing.reportTypeSelect.optionName.investmentReport';
      return 'briefing.popup.createBriefing.reportTypeSelect.optionName.investmentReport';
    }

    if (mediaType.toUpperCase().includes('SOCIAL_MEDIA')) {
      tempReportTypeText = 'briefing.popup.createBriefing.reportTypeSelect.optionName.socialMedia';
      return 'briefing.popup.createBriefing.reportTypeSelect.optionName.socialMedia';
    }
  });

  return tempReportTypeText;
}

export function getPositionOfEventScroll(event, widget): number {
  const element = event.target as HTMLElement;
  const rect = element.getBoundingClientRect();
  // console.log("widget.getBoundingClientRect().top: ",widget.getBoundingClientRect().top)
  return rect.top + window.scrollY + widget.getBoundingClientRect().top;
}

export function getFaviconByUrl(websiteUrl: string): string {
  try {
    const url = new URL(websiteUrl);
    return `${url.origin}/favicon.ico`;
  } catch (e) {
    return '';
  }
}

export function checkIsFileByDocument(documentInput: any): boolean {
  try {
    let result = false;

    if (
      (documentInput.path?.includes('opt/deepsignal/download') ||
        (documentInput.path?.includes('UID_') &&
          documentInput.path?.includes('T') &&
          documentInput.path?.includes('Z_') &&
          documentInput.path?.includes('.'))) &&
      FILE_TYPES.some(item => documentInput.path?.includes(item))
    ) {
      result = true;
    }

    return result;
  } catch (e) {
    return false;
  }
}

export function checkIsNoteByDocument(documentInput: any): boolean {
  try {
    let result = false;

    if (documentInput?.id?.includes('usernote')) {
      result = true;
    }

    return result;
  } catch (e) {
    return false;
  }
}

export function calculateReadTime(content) {
  const wordsPerMinute = 200; // Average reading speed
  const text = content.trim();
  const wordCount = text.split(/\s+/).length;
  return Math.ceil(wordCount / wordsPerMinute);
}

export function deepEquals(o1: any, o2: any): boolean {
  return JSON.stringify(o1) === JSON.stringify(o2);
}

export function getFacebookPostId(url) {
  const match = url.match(/facebook\.com\/[^/]+\/posts\/(\d+)/);
  return match ? `@${match[1]}` : '@Facebook';
}

export function getXStatusId(url) {
  const match = url.match(/x\.com\/i\/web\/status\/(\d+)/);
  return match ? `@${match[1]}` : '@X';
}
